import { render, staticRenderFns } from "./TeacherMappingTable.vue?vue&type=template&id=3e225fff&"
import script from "./TeacherMappingTable.vue?vue&type=script&lang=js&"
export * from "./TeacherMappingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports